import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  activeCounter: 'session',
  session: 1500,
  break: 300,
  timer: 1500,
}

export const lycopersicumSlice = createSlice({
  name: 'lycopersicum',
  initialState: { ...defaultState },
  reducers: {
    increaseLength: (state, action) => {
      state[action.payload] =
        state[action.payload] <= 3540 ?
          state[action.payload] + 60 : state[action.payload]
      if (action.payload === state.activeCounter) {
        state.timer = state[action.payload]
      }
    },
    decreaseLength: (state, action) => {
      state[action.payload] =
        state[action.payload] > 60 ?
          state[action.payload] - 60 : state[action.payload]
      if (action.payload === state.activeCounter) {
        state.timer = state[action.payload]
      }
    },
    changeActiveCounter: state => {
      state.activeCounter =
        state.activeCounter === 'session' ?
          'break' : 'session'
      state.timer = state[state.activeCounter]
    },
    countDown: state => {
      state.timer = state.timer - 1
    },
    resetCounter: state => {
      state = Object.assign(state, defaultState)
    },
  },
})

export default lycopersicumSlice.reducer